/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var productJsonElement = document.querySelector('[data-product-json]');
if (productJsonElement) {
    var jsonData = JSON.parse(productJsonElement.innerHTML); 
} 

document.addEventListener('variant:changed', function(event) {
	if ( ! jsonData) {
		return false;
	}

	var variant = event.detail.variant;

	if (jsonData['inventories'][variant.id]['max_qty'] == null || jsonData['inventories'][variant.id]['max_qty'] == false) {
      return false;
    }

    var maxQty = jsonData['inventories'][variant.id]['max_qty'];
    var quantitySelectorContainerEl = document.querySelector('.product-form .product-form__info-item--quantity .product-form__info-content');
    var maxQtyMessageEl = document.querySelector('.product-form .product-form__max-qty-message');

    if (maxQtyMessageEl == null) {
      // Create max qty message element
      maxQtyMessageEl = document.createElement('p');
      maxQtyMessageEl.classList.add('product-form__max-qty-message');

      quantitySelectorContainerEl.appendChild(maxQtyMessageEl);
    }

    // Update max qty message
    maxQtyMessageEl.innerText = 'Limited to max. ' + maxQty + ' per customer';

    // Update qty select options
    var qtySelectorEl = document.querySelector('.product-form__info-item--quantity select.product-form__quantity');
    var qtySelectOptionsHTML = '';
    for (var i = 1; i <= maxQty; i++) {
      qtySelectOptionsHTML += '<option value="' + i + '"' + (i==1 ? ' selected="selected"' : '') + '>' + i + '</option>';
    }

    qtySelectorEl.innerHTML = qtySelectOptionsHTML;
});

/** 
* Load custom order statuses
*/
var OrderStatus = function () {
	var orderList = document.getElementById('order-list');

	if (orderList != null) {
		var orderStatuses = orderList.querySelectorAll('.order-status');

		for (var i=0; i < orderStatuses.length; i++) {
			var orderStatus = orderStatuses[i];
			var orderId = orderStatus.dataset.orderId;
			var orderEmail = orderStatus.dataset.orderEmail;

			fetch('https://orderstatus.w3apps.co/api/OrderLookup', {
	          body: JSON.stringify({
			    shopName: 'crashrecords',
			    emailAddress: orderEmail,
			    orderNumber: orderId
			  }),
	          method: 'POST',
	          headers: {
	            'Content-Type': 'application/json',
	            'X-Requested-With': 'XMLHttpRequest'
	          }
	        }).then(response => response.json())
			.then(data => {
			  var responseDoc = new DOMParser().parseFromString(data.searchresultsdetail, "text/html");
			  var customStatus = responseDoc.getElementById('w3_order_status').textContent;
			  var orderNumber = responseDoc.getElementById('order_number').textContent;

			  if ("" !== customStatus) {
			  	var statusEl = document.querySelector('#order-list .order-status[data-order-id="' + orderNumber + '"] .status');
			  	if ('undefined' != typeof(statusEl) && statusEl != false) {
			  		statusEl.innerHTML = customStatus;
			  	}
			  }
			})
			.catch((error) => {
			  console.error('Error:', error);
			});
		}
	}
}
OrderStatus();